<template>
    <div class="debugger-wrapper" id="debugger-state">
        <button class="toggle-btn" @click="toggleVisible">
            {{ visible ? '+' : '-' }}
        </button>

        <div class="debugger" v-show="visible">
            <h3>🔍 Pinia State Debugger (Multi-Store)</h3>
            <div v-html="stateHtml"></div>
        </div>
    </div>
</template>

<script>
import {watch} from 'vue'
import {useImprintStore} from "../stores/useImprintStore";
import {useNewImprintStore} from "../stores/useNewImprintStore";
import {useSelectionStore} from "../stores/useSelectionStore";
import {useAppStore} from "../stores/useAppStore";
import {useAddToCartStore} from "../stores/useAddToCart";

export default {
    name: 'StateDebuggerOptions',
    data() {
        return {
            visible: true,
            stateHtml: '',
            stores: [
                {name: 'ImprintStore', store: useImprintStore()},
                {name: 'NewImprintStore', store: useNewImprintStore()},
                {name: 'SelectionStore', store: useSelectionStore()},
                {name: 'AppStore', store: useAppStore()},
                {name: 'AddToCart', store: useAddToCartStore()},
            ]
        }
    },
    mounted() {
        // Subscribe for all store changes
        this.stores.forEach(s => {
            watch(
                () => s.store.$state,
                () => this.updateStateHtml(),
                {deep: true, immediate: true}
            )
        })
    },
    methods: {
        toggleVisible() {
            this.visible = !this.visible
        },
        // Recursive function for <details>
        objToHtml(obj) {
            if (typeof obj !== 'object' || obj === null) return `<span>${obj}</span>`

            let html = '<ul>'
            for (const key in obj) {
                const value = obj[key]
                if (typeof value === 'object' && value !== null) {
                    html += `<li><details><summary>${key}</summary>${this.objToHtml(value)}</details></li>`
                } else {
                    html += `<li>${key}: ${value}</li>`
                }
            }
            html += '</ul>'
            return html
        },
        updateStateHtml() {
            let html = ''
            this.stores.forEach(s => {
                html += `<details open><summary style="font-weight:bold">${s.name} Store</summary>${this.objToHtml(s.store.$state)}</details>`
                // console.log(`%c${s.name} Store changed:`, 'color: #4caf50', s.store.$state)
            })
            this.stateHtml = html
        }
    }
}
</script>

<style scoped lang="scss">
@use '@/styles/components/state-debugger';
</style>
